﻿import { opaccLogPlugin } from "./vendor/script/opacc.static.js";

(function ($) {
  $.fn.extend({
    donetyping: function (callback, timeout) {
      timeout = timeout || 1e3; // 1 second default timeout
      var timeoutReference,
        doneTyping = function (el) {
          if (!timeoutReference) return;
          timeoutReference = null;
          callback.call(el);
        };
      return this.each(function (i, el) {
        var $el = $(el);
        // Chrome Fix (Use keyup over keypress to detect backspace)
        // thank you @palerdot
        $el.is(":input") &&
          $el
            .on("keyup keypress paste", function (e) {
              // This catches the backspace button in chrome, but also prevents
              // the event from triggering too preemptively. Without this line,
              // using tab/shift+tab will make the focused element fire the callback.
              if (e.type == "keyup" && e.keyCode != 8) return;

              // Check if timeout has been set. If it has, 'reset' the clock and
              // start over again.
              if (timeoutReference) clearTimeout(timeoutReference);
              timeoutReference = setTimeout(function () {
                // if we made it here, our timeout has elapsed. Fire the
                // callback
                doneTyping(el);
              }, timeout);
            })
            .on("blur", function () {
              // If we can, fire the event since we're leaving the field
              doneTyping(el);
            });
      });
    },
  });
})(jQuery);

// $(document).on('ajaxSuccess', function () {
//   recalcPositions();
// });

// $(document).ready(function () {
//   recalcPositions();
// });

function isNormalInteger(str) {
  var n = Math.floor(Number(str));
  return n !== Infinity && String(n) === str && n > 0;
}

// Funktion zum Binden des KP Search Input Field

function initEleQuantity() {
  $(".ele-quantity").donetyping(function () {
    var url = $(this).parent().data("url");
    var form_item = $(this).closest(".basket-list-item");
    var original_val = $(this).data("value");

    if ($(this).closest(".child-item").length == 0) {
      if (!isNormalInteger(this.value)) {
        this.value = original_val;
        shake(this);
      }
    }

    $(this).data("value", this.value);

    var quantity = this.value;

    $.ajax({
      type: "POST",
      url: url,
      data: {
        txtquantity: quantity,
      },
    }).done(function (data) {
      data = $.parseJSON(data);
      // $(".amntcharge3value",form_item).html(data.ItemAmntCharge3Value);
      // $(".salesprice",form_item).html(data.ItemSalesPrice);
      // $(".AmntCharge2",form_item).html(data.ItemAmntCharge2);
      // $(".AmntCharge3",form_item).html(data.ItemAmntCharge3);
      // $(".ItemAmount",form_item).html(data.ItemAmount);
      // $(".docAmount").html(data.DocAmount);
      // $(".docTotalVat").html(data.DocTotalVat);
      // $(".docDocCharge4Value").html(data.DocCharge4Value);
      // $(".DocTotalInclVat").html(data.DocTotalInclVat);
      // $(".docAmntCharge3").html(data.DocAmntCharge3);
      // $(".docAmntCharge1").html(data.DocAmntCharge1);
      $(".NormenbasketTotalIncl").html(data.NormenDocTotalInclVat);
      $(".WBbasketTotalIncl").html(data.WBDocTotalInclVat);
      $(".basketTotalIncl").html(data.TotalBasketInclVat);
      $(".basketTotalIncl").html(data.TotalBasketInclVat);
      $.ajax({
        type: "GET",
        url: $("#asyn-normen-basket").data("url"),
      }).done(function (data) {
        $("#normen-basket-wrapper").html(data);
        initEleQuantity();
      });
    });
  }, 400);
}
initEleQuantity();

const shake = (e, distance = 5, duration = 500) => {
  // shake element e left and right.
  const originalStyle = e.style.cssText;
  e.style.position = "relative";
  const startTime = new Date().getTime();

  const animateIt = () => {
    const now = new Date().getTime();
    const elapsedTime = now - startTime;
    const fraction = elapsedTime / duration;

    if (fraction < 1) {
      let x = distance * Math.sin(fraction * 4 * Math.PI);
      e.style.left = x + "px";
      setTimeout(animateIt, Math.min(25, duration - elapsedTime));
    } else {
      e.style.cssText = originalStyle;
    }
  };

  animateIt();
};

$(".opc-cust-basket-button input").donetyping(function () {
  if (!isNormalInteger(this.value)) {
    this.value = 1;
    shake(this);
  }
}, 100);

$(".el-ke-additional-infos input").donetyping(function () {
  var data = $(this).attr("name");
  var Remark = $(this)
    .closest(".el-eventgroup-item")
    .find(".remark:first")
    .val();
  var PosText = $(this)
    .closest(".el-eventgroup-item")
    .find(".notes:first")
    .val();

  $.ajax({
    type: "POST",
    url: $("#asyn-basket-url-set-additional-info").data("url"),
    data: {
      id: data,
      PosText: PosText,
      Remark: Remark,
    },
  }).done(function (data) {});
}, 300);

$("#ele_nin_clubtoggle").click(function () {
  var elem = this;
  $.ajax({
    type: "GET",
    url: $(elem).data("url"),
  }).done(function (data) {
    window.location.href = window.location.href;
  });
});

// Funktion zum Binden des KP Search Input Field
$(".el-member-search").donetyping(function () {
  var data = this.value;
  var item = $(this).data("id");
  var artno = $(this).data("artno");
  var currentelem = this;
  var container = $(currentelem)
    .closest(".el-eventgroup-item")
    .find(".el-tn-search-wrapper");

  if (this.value == "") {
    $(container).empty();
  } else {
    $.ajax({
      type: "POST",
      url: $("#asyn-basket-url-get-kp").data("url"),
      data: {
        data: data,
        item: item,
        artno: artno,
      },
    }).done(function (data) {
      $(container).empty().append(data);
    });
  }
}, 200);

$(document).on("focus", ".el-member-search", function () {
  var item = $(this).data("id");
  var container = $(this)
    .parent()
    .parent()
    .parent()
    .next("div.el-tn-search-wrapper");
  var artno = $(this).data("artno");
  if (this.value == "") {
    $.ajax({
      type: "POST",
      url: $("#asyn-basket-url-get-kp").data("url"),
      data: {
        data: "*",
        item: item,
        artno: artno,
      },
    }).done(function (data) {
      $(container).empty().append(data);
    });
  }
});

// Binden der Warenkorbfunktionalitï¿½t
$(document).on("click", ".el-basket-event-option-item", function (event) {
  var transactionId = $(this).data("transaction-id");
  var url = $("#asyn-basket-url-udpdate").data("url") + "?bwb=true";
  var currentelem = this;
  var priceState = "";
  var streamartno = $(this).data("streamartno");
  var wrapper = $(this).closest(".el-eventgroup-item");
  var preventGetEventGroup =
    wrapper && wrapper.data("prevent-request") ? "true" : "false";

  var doReload = $(this).attr("data-perform-reload");

  if ($(this).prop("checked")) {
    var data = $(this).data("transaction-on");
    priceState = "on";
  } else {
    var data = $(this).data("transaction-off");
    priceState = "off";
  }

  if (doReload) {
    $("body").addClass("wait");
  }

  $.ajax({
    type: "POST",
    url: url,
    data: {
      id: transactionId,
      data: data,
      streamartno: streamartno,
      preventGetEventGroup: preventGetEventGroup,
      reload: doReload,
    },
  }).done(function (data) {
    // Neues HTML als jQuery-Elemente und als echtes Dokument verarbeiten
    var parsedElements = $.parseHTML(data);
    var parsedDoc = new DOMParser().parseFromString(data, "text/html");

    // Neue Inhalte in bestehende Bereiche einfügen
    $(".basket-list-summary-wrapper")
      .html
      // parsedDoc.querySelector(".basket-list-summary-wrapper")
      ();
    $(".basket-list-wb-wrapper")
      .html
      // parsedDoc.querySelector(".basket-list-wb-wrapper")
      ();

    // Wrapper-ID aus dem ersten <div> im neuen HTML holen
    var wrapperId = $("div:first", parsedElements).data("wrapper");

    // Altes Event-Element entfernen
    $(".el-event-group-" + wrapperId).remove();

    // Neue Elemente mit passender Klasse aus dem geladenen HTML extrahieren
    var newGroupElements = $(".el-event-group-" + wrapperId, parsedElements);

    // Bestehende Gruppen auf der Seite mit neuen Inhalten aktualisieren
    $(".group-wrapper-" + wrapperId).each(function (i) {
      $(this).html(newGroupElements[i]);
    });

    // Perform pagereload to update price
    const clickedElement = event.target;
    if (clickedElement && clickedElement.hasAttribute("data-perform-reload")) {
      location.reload();
    }
  });
});

// Binden der Stream Items
$(document).on("click", ".stream-list .opc-radio", function () {
  var url = $("#asyn-basket-url-reset-stream-option").data("url");
  var currentelem = $("input", this);
  var datafilter = "";

  //$('input[name=\'' + this.name + '\']').each(function(i) {});

  var transactionId = $(currentelem).data("transaction-id");
  var datafilter = $(currentelem).data("transaction-filter");

  // prop('checked','');
  // $(this).prop('checked','checked');

  $.ajax({
    type: "POST",
    url: url,
    data: {
      id: transactionId,
      filter: datafilter,
    },
  }).done(function (data) {
    var url = $("#asyn-basket-url-udpdate").data("url");
    var transactionId = $(currentelem).data("transaction-id");
    var data = $(currentelem).data("transaction-value");
    $.ajax({
      type: "POST",
      url: url,
      data: {
        id: transactionId,
        data: data,
      },
    }).done(function (data) {
      $(currentelem).parent().parent().find(".prc").attr("data-state", "off");
      $(currentelem).parent().find(".prc:first").attr("data-state", "on");
      //recalcPositions();
    });
  });
});

$(document).on("click", ".tn-select .select-item", function () {
  var elem = this;
  var url = $(this).closest(".list-item").data("url-add");
  var data = $(this).data("transaction-data");
  var user = $(this).closest(".list-item").data("full-name");

  $.ajax({
    type: "POST",
    url: url,
  }).done(function (data) {
    var item =
      $(elem).closest(".el-eventgroup-item").length > 0
        ? $(elem).closest(".el-eventgroup-item").find(".el-tn-search-container")
        : $(elem)
            .closest(".el-eventgrou-item-body")
            .find(".el-tn-search-container");
    $(item).find("input").addClass("hidden");
    $(item).find("span").removeClass("hidden").text(user);
    $(item).find("button.edit-contact").removeClass("hidden");
    $(elem).closest(".el-tn-search-wrapper").html("");
  });
});

$(document).on("click", ".mutate-add", function () {
  var elem = this;
  var url = $(this).closest(".list-item").data("url-edit");
  var data = $(this)
    .closest(".list-item")
    .find("select,input")
    .serializeArray();
  var valid = true;

  $(this)
    .closest(".list-item")
    .find("select,input")
    .each(function () {
      if (!this.checkValidity()) {
        $(this).addClass("error");
        valid = false;
      } else {
        $(this).removeClass("error");
      }
    });

  var user =
    $(this).closest(".list-item").find("input[name='txtFirstName']").val() +
    " " +
    $(this).closest(".list-item").find("input[name='txtLastName']").val();

  if (valid) {
    $(elem)
      .parent()
      .parent()
      .find(".opc-form-field,.visible")
      .toggleClass("hidden");

    $.ajax({
      type: "POST",
      url: url,
      data: data,
    }).done(function (data) {
      var item = $(elem)
        .closest(".el-eventgroup-item")
        .find(".el-tn-search-container");
      $(item).find("input").addClass("hidden").val("");
      $(item).find("span").removeClass("hidden").html(user);
      $(item).find("button.edit-contact").removeClass("hidden");
      $(elem).closest(".el-tn-search-wrapper").html("");
    });
  }
});

$(document).on("click", ".new-add", function () {
  var elem = this;

  var url = $(this).closest(".list-item").data("url-new");
  var data = $(this)
    .closest(".list-item")
    .find("select,input")
    .serializeArray();
  var user =
    $(this).closest(".list-item").find("input[name='txtFirstName']").val() +
    " " +
    $(this).closest(".list-item").find("input[name='txtLastName']").val();
  var valid = true;

  $(this)
    .closest(".list-item")
    .find("select,input")
    .each(function () {
      if (!this.checkValidity()) {
        $(this).addClass("error");
        valid = false;
      } else {
        $(this).removeClass("error");
      }
    });

  if (valid) {
    $.ajax({
      type: "POST",
      url: url,
      data: data,
    }).done(function (data) {
      if ($(".error", data).text() == "error") {
        opaccLogPlugin.showError($(".message", data).text());
      } else {
        var item = $(elem)
          .closest(".el-eventgroup-item")
          .find(".el-tn-search-container");
        $(item).find("input").addClass("hidden").val("");
        $(item).find("span").removeClass("hidden").html(user);
        $(elem).closest(".el-tn-search-wrapper").html("");
      }
    });
  }
});

$(document).on("click", ".validate", function () {
  let valid = true;
  let $firstInvalidElement = null; // zum späteren Fokussieren/Scrollen

  // === 1. Checkbox-Gruppen prüfen ===
  const checkboxGroups = {};

  $('input[type="checkbox"][data-group-id]').each(function () {
    const groupId = $(this).data("group-id");
    checkboxGroups[groupId] = checkboxGroups[groupId] || [];
    checkboxGroups[groupId].push(this);
  });

  $.each(checkboxGroups, function (groupId, boxes) {
    const $boxes = $(boxes);
    const isChecked = $boxes.filter(":checked").length > 0;
    const $errorDiv = $(`[data-error-message="${groupId}"]`);

    if (!isChecked) {
      valid = false;
      $errorDiv.removeClass("hidden");

      // Fokus nur beim ersten invaliden Element setzen
      if (!$firstInvalidElement) {
        $firstInvalidElement = $boxes.first();
      }
    } else {
      $errorDiv.addClass("hidden");
    }
  });

  // === 2. Radio-Gruppen mit required prüfen ===
  $('input[type="radio"][required]').each(function () {
    const name = $(this).attr("name");
    const $group = $(`input[name="${name}"]`);
    const $errorDiv = $(`[data-error-message="${name}"]`);

    if ($group.filter(":checked").length === 0) {
      valid = false;
      $errorDiv.removeClass("hidden");

      if (!$firstInvalidElement) {
        $firstInvalidElement = $group.first();
      }
    } else {
      $errorDiv.addClass("hidden");
    }
  });

  if ($(".el-member-search:visible").length > 0) {
    $(".el-member-search:visible")
      .closest(".opc-form-field")
      .addClass("is-invalid");
    $(".el-member-search:visible").filter(":first").focus();
    valid = false;
  }

  // === 3. Falls Fehler vorhanden, Fokus setzen & Scrollen ===
  if (!valid) {
    if ($firstInvalidElement && $firstInvalidElement.length) {
      // sanft scrollen
      $("html, body").animate(
        {
          scrollTop: $firstInvalidElement.offset().top - 300,
        },
        500,
        function () {
          $firstInvalidElement.focus();
        }
      );
    }
  }

  if (valid) {
    window.location.href = $(this).data("url");
  }
});

function number_format(number, decimals, dec_point, thousands_sep) {
  var exponent = "";
  var numberstr = number.toString();
  var eindex = numberstr.indexOf("e");
  var i = 0;
  var z = 0;
  if (eindex > -1) {
    exponent = numberstr.substring(eindex);
    number = parseFloat(numberstr.substring(0, eindex));
  }

  if (decimals != null) {
    var temp = Math.pow(10, decimals);
    number = Math.round(number * temp) / temp;
  }
  var sign = number < 0 ? "-" : "";
  var integer = (
    number > 0 ? Math.floor(number) : Math.abs(Math.ceil(number))
  ).toString();

  var fractional = number.toString().substring(integer.length + sign.length);
  dec_point = dec_point != null ? dec_point : ".";
  fractional =
    (decimals != null && decimals > 0) || fractional.length > 1
      ? dec_point + fractional.substring(1)
      : "";
  if (decimals != null && decimals > 0) {
    for (i = fractional.length - 1, z = decimals; i < z; ++i) fractional += "0";
  }

  thousands_sep =
    thousands_sep != dec_point || fractional.length == 0 ? thousands_sep : null;
  if (thousands_sep != null && thousands_sep != "") {
    for (i = integer.length - 3; i > 0; i -= 3)
      integer = integer.substring(0, i) + thousands_sep + integer.substring(i);
  }

  return sign + integer + fractional + exponent;
}




